export { default } from "./SiteFooter";
